// GET REQUEST WITH QUERY PARAMS FOR SEARCH AND

import { apiRequest } from "../configs/axios.config";
import { createSearchParams } from "react-router-dom";

interface IGetRequest {
  url: string;
  searchParams?: any;
  signal?: AbortSignal;
}

//PAGINATION PURPOSE (FOR EXAMPLE: /api/v1/locations/states?filter[name]=lagos&page=1)
const handleGlobalGetRequestQuery = ({
  url,
  searchParams = {},
  signal,
}: IGetRequest) => {
  const searchParamsObject = createSearchParams(searchParams).toString();
  return apiRequest
    .get(url + "?" + searchParamsObject, { signal })
    .then((response) => response.data);
};

export { handleGlobalGetRequestQuery };
